import { createSlice } from "@reduxjs/toolkit/"

let initialState = {
    attemptedQuizzList : [],
    selectedAttemptedQuizz:{},
}
const attemptedQuizzSlice = createSlice({
    name:'attemptedquizz',
    initialState,
    reducers:{
        setAttemptedQuizzList:(state,{payload})=>{
            state.attemptedQuizzList = payload
        },
        setAttemptedQuizzProfile:(state,{payload})=>{
            state.selectedAttemptedQuizz = payload
        },
    }
})

export const { setAttemptedQuizzList,setAttemptedQuizzProfile} = attemptedQuizzSlice.actions
export default attemptedQuizzSlice.reducer